import ShiftColorSelector from "./shift-color-selector";

export default ShiftColorSelector;
